import React from 'react';
import {Form, Formik, Field, FastField} from 'formik';
import {FormattedMessage} from 'react-intl';
import {constants} from '@neosvoc/nv-platform-core-common';
import yup from '../../yup';
import messages from '../../../res/translations/messages';
import FormGroupField from '../admin/FormGroupField';
import UploaderField from './UploaderField';
import ResetBrandingButton from './ResetBrandingButtons';
import {availableFonts, colorRegex, fontLabels} from '../../constants';
import {buttonsSchema} from '../admin/uiForms/validations';
import ButtonForm from '../admin/uiForms/ButtonForm';
import {getButtonsStyle} from '../../utils/branding';
import BrandingFormItem from './BrandingFormItem';


const brandingSchema = yup.object().shape({
    primaryColor: yup.string().matches(colorRegex),
    secondaryColor: yup.string().matches(colorRegex),
    backgroundColor: yup.string().matches(colorRegex),
    font: yup.string().oneOf(availableFonts),
    logo: yup.string().url(),
    ui: yup.object().shape({
        buttons: buttonsSchema,
    }),
});

const defaultBranding = {
    primaryColor: '#119bd6',
    secondaryColor: '#f1d02d',
    backgroundColor: '#ffffff',
    successColor: '#78e861',
    font: constants.BRANDING_FONTS.WORK_SANS,
    logo: '',
};

const BrandingForm = ({item, loading, onReset, onSubmit}) => {
    const [saved, setSaved] = React.useState(false);
    const prevLoadingRef = React.useRef(loading);
    React.useEffect(() => {
        if (prevLoadingRef.current && !loading) {
            setSaved(true);
            const t = setTimeout(() => setSaved(false), 4000);
            return () => clearTimeout(t);
        }
        prevLoadingRef.current = loading;
    }, [loading]);

    const orgBranding = {primaryColor: item.branding.primaryColor || defaultBranding.primaryColor,
        secondaryColor: item.branding.secondaryColor || defaultBranding.secondaryColor,
        backgroundColor: item.branding.backgroundColor || defaultBranding.backgroundColor,
        successColor: item.branding.successColor || defaultBranding.successColor,
        font: item.branding.font || defaultBranding.font,
        logo: item.branding.logo || defaultBranding.logo,
    };
    return (
        <Formik
            initialValues={{
                ...orgBranding,
                ui: {
                    buttons: getButtonsStyle(item.branding.ui, defaultBranding.primaryColor),
                },
            }}
            enableReinitialize={true}
            isInitialValid={true}
            onSubmit={onSubmit}
            validationSchema={brandingSchema}
        >
            {({isValid, values}) => (
                <Form>
                    <div className="survey-create-box">
                        {saved && (
                            <div className="alert alert-success">
                                <FormattedMessage id="admin.branding.saved" defaultMessage="Branding saved" />
                            </div>
                        )}
                        <div className="col">
                            <div className="row">
                                <div className="col">
                                    <div className="form-group">
                                        {/* <label htmlFor="branding-logo" className="col-form-label">
                <FormattedMessage {...messages.admin.branding.logo} />
                {values.logo && <img src={values.logo} className="img-thumbnail d-block" style={{maxHeight: 200, maxWidth: 700}} />}
                </label> */}
                                        <Field name="logo" component={UploaderField} id="branding-logo" />
                                    </div>
                                </div>
                                <div className="col">
                                    <label className="col-form-label" htmlFor="branding-font"><FormattedMessage {...messages.admin.branding.font} /></label>
                                    <FastField id="branding-font" name="font" className="form-control custom-select" component="select">
                                        {fontLabels.map(({key, label}) => (<option key={`font_${key}`} value={key}>{label}</option>))}
                                    </FastField>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <FormGroupField type="color" id="branding-primary_color" name="primaryColor"
                                        label={messages.admin.branding.primaryColor} />
                                </div>
                                <div className="col">
                                    <FormGroupField type="color" id="branding-secondary_color" name="secondaryColor"
                                        label={messages.admin.branding.secondaryColor} />
                                </div>
                                <div className="col">
                                    <FormGroupField type="color" id="branding-success_color" name="successColor"
                                        label={messages.admin.branding.successColor} />
                                </div>
                                <div className="col">
                                    <FormGroupField type="color" id="branding-background_color" name="backgroundColor"
                                        label={messages.admin.branding.backgroundColor} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <BrandingFormItem title={<FormattedMessage {...messages.admin.branding.uiForms.buttons} />}>
                                        <ButtonForm buttonBranding={values.ui.buttons} />
                                    </BrandingFormItem>
                                </div>
                            </div>
                        </div>
                        <div className="col text-right">
                            <ResetBrandingButton type="button" className="btn btn-outline-danger mr-2" disabled={loading} onClick={onReset}>
                                <FormattedMessage {...messages.admin.branding.reset} />
                            </ResetBrandingButton>
                            <button type="submit" className="btn btn-primary">
                                <FormattedMessage {...messages.buttons.save} />
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default BrandingForm;
